import React from 'react';
import { CheckCircle, XCircle, Edit2 } from 'lucide-react';
import { InvalidConfigType } from '../MaintenanceDraft/utils/configValidation';

interface ConfigTypeRowProps {
    type: InvalidConfigType;
    onEdit: (componentType: string) => void;
}

const ConfigTypeRow: React.FC<ConfigTypeRowProps> = ({ type, onEdit }) => {
    const { componentType, typeName, validation, componentCount } = type;
    const complete = validation.hasExpectedLifetime && validation.hasReplacementCost;

    return (
        <div className="config-validation-row">
            <div className="config-row-content">
                <div className="type-info-section">
                    <h5 className="type-name">{typeName}</h5>
                    <div className="type-meta">
                        <span className="component-count text-muted">
                            {componentCount} {componentCount === 1 ? 'komponent' : 'komponenter'} i byggnaden
                        </span>
                    </div>
                    <div className="validation-indicators">
                        <div className={`indicator ${complete ? 'valid' : 'invalid'}`}>
                            {complete ? (
                                <CheckCircle size={16} className="me-1" />
                            ) : (
                                <XCircle size={16} className="me-1" />
                            )}
                            <span>
                                {complete ? (
                                    <>
                                        Livslängd: {validation.expectedLifetimeYears} år,
                                        Utbyteskostnad: {validation.replacementCost?.toLocaleString('sv-SE')} kr
                                    </>
                                ) : (
                                    <>
                                        {!validation.hasExpectedLifetime && !validation.hasReplacementCost && 'Saknar livslängd och utbyteskostnad'}
                                        {!validation.hasExpectedLifetime && validation.hasReplacementCost && 'Saknar livslängd'}
                                        {validation.hasExpectedLifetime && !validation.hasReplacementCost && 'Saknar utbyteskostnad'}
                                    </>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="config-actions">
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={() => onEdit(componentType)}
                    >
                        <Edit2 size={14} className="me-1" />
                        {!validation.hasExpectedLifetime && !validation.hasReplacementCost
                            ? 'Ange värden'
                            : 'Redigera'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfigTypeRow;
